export const colors = {
	primary: '#6f55ff',
	white: '#ffffff',
	red: 'red',
	green: 'green',
};
